export default __webpack_public_path__ + "static/orchestrafromabove-506bea8ccc1bcb194b79c2045dab9c4b.jpg";